/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResellerMasterdata } from '../../models/reseller-masterdata';
import { ResellerUpdateRequest } from '../../models/reseller-update-request';

export interface PutReseller$Params {
  resellerId: string;
  'Active-Tenant-Identifier': string;
      body: ResellerUpdateRequest
}

export function putReseller(http: HttpClient, rootUrl: string, params: PutReseller$Params, context?: HttpContext): Observable<StrictHttpResponse<ResellerMasterdata>> {
  const rb = new RequestBuilder(rootUrl, putReseller.PATH, 'put');
  if (params) {
    rb.path('resellerId', params.resellerId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResellerMasterdata>;
    })
  );
}

putReseller.PATH = '/resellers/{resellerId}';
